import React, { useState, useCallback, useRef, useEffect } from 'react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';

interface MapComponentProps {
  center: google.maps.LatLngLiteral;
  zoom: number;
  markers: { position: google.maps.LatLngLiteral; title: string }[];
  onMapClick: (event: google.maps.MapMouseEvent) => void;
}

const mapContainerStyle = {
  height: '100%',
  width: '100%',
};

const libraries: ("places" | "drawing" | "geometry" | "localContext" | "visualization")[] = ['places'];

const googleMapKey: string | undefined = process.env.REACT_APP_GOOGLE_MAP_KEY;
const MapComponent: React.FC<MapComponentProps> = ({ center, zoom, markers, onMapClick }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapKey!,
    libraries,
  });

  const [mapCenter, setMapCenter] = useState(center);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

  useEffect(() => {
    if (markers.length > 0) {
      setMapCenter(markers[0].position); // Center on the first marker
    }
  }, [markers]);

  const handleMapClick = useCallback((event: google.maps.MapMouseEvent) => {
    onMapClick(event);
  }, [onMapClick]);

  //code to implement autocomplete
  const onAutocompleteLoad = (autocomplete: google.maps.places.Autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry && place.geometry.location) {
        setMapCenter({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });
      }
    }
  };

  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={mapCenter}
          zoom={zoom}
          onClick={handleMapClick}
        >
          {markers && markers.map((marker, index) => (
            <Marker
              key={index}
              position={marker.position}
              title={marker.title}
            />
          ))}
        </GoogleMap>
      )}
    </>
  );
};

export default MapComponent;
